import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils'; // Assuming a utils file exists or I'll inline it if not, but standard pattern usually implies one. I'll stick to inline classes to be safe.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export const Button = ({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  onClick,
  ...props
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#2ABFBF] text-white hover:bg-[#25a9a9] shadow-lg shadow-[#2ABFBF]/20 hover:shadow-[#2ABFBF]/40',
    secondary: 'bg-[#E8734A] text-white hover:bg-[#d6633c] shadow-lg shadow-[#E8734A]/20',
    outline: 'border-2 border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A]/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      window.open('https://claridapaso.com/cart/48490354213107:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} onClick={handleClick} {...props as any} data-id="element-176">
      {"Quiero mi Ruta Clara \u2014 "}
    </motion.button>;
};